import { FC, Suspense } from 'react'
import { useRoutes } from 'react-router-dom'

import { Preloader } from '@procom-labs/atoms'
import { useAuthInitializer } from '@procom-labs/common'
import {
  AlertContextProvider,
  NewAppVersionPrompt,
} from '@procom-labs/molecules'

import { commonRoutes } from './common'
import { privateRoutes } from './private'
import { publicRoutes } from './public'

export const AppRoutes: FC = () => {
  const { authInitialized, isAuthenticated } = useAuthInitializer()

  const featureRoutes = useRoutes(
    isAuthenticated
      ? [...privateRoutes, ...commonRoutes]
      : [...publicRoutes, ...commonRoutes]
  )

  if (authInitialized)
    return (
      <AlertContextProvider>
        <Suspense fallback={<Preloader center />}>
          {featureRoutes}
          <NewAppVersionPrompt />
        </Suspense>
      </AlertContextProvider>
    )

  return <Preloader center />
}
